module.exports = __webpack_public_path__ + "static/banner-part-3-2-2ddc70171c10720472e0b132c7564122.svg";